import styled, { css } from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

import { customScrollMinimal } from '../custom-scroll/CustomScroll.styles';
import { DropdownListItem } from '../dropdown/dropdown-list-item/DropdownListItem';

export const Aside = styled.aside`
  position: fixed;
  top: var(--app-header-height, 0);
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 288px;
  border-right: 1px solid var(--border-soft);
`;

export const Title = styled.h2`
  ${typographyV2.titleXL}
  padding:20px 24px;
`;

export const Categories = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-top: 1px solid var(--border-soft);
  padding: 16px 0px;
  gap: 16px;
  overflow-y: scroll;
  ${customScrollMinimal}
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CategoryTitle = styled.h4`
  color: var(--text-soft);
  text-transform: uppercase;
  ${typographyV2.bodyXs};
  padding: 0px 8px 0px 24px;
`;

export const Items = styled.ul`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  gap: 4px;
  list-style-type: none;
`;

export const Item = styled.li``;

export const StyledDropdownListItem = styled(DropdownListItem)`
  position: relative;
  padding: 8px 16px;
  margin: 0px 0px 0px 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  ${DropdownListItem.Styled.MainLabel} {
    ${typographyV2.bodyBase};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      ${DropdownListItem.Styled.MainLabel} {
        color: var(--text-primary);
      }

      & svg {
        fill: var(--icon-primary);
      }

      &::before {
        left: unset;
        right: calc(100% + 4px);
        border-radius: 0px 2px 4px 0px;
        height: 100%;
      }
    `}
`;
